//@core
const apiURLBuilder = require('core/apiURLBuilder');
//@services
const Api = require('services/api');

const checkPinCard = (accessToken, pin, callback) => {
    const url = apiURLBuilder.getURL('debitCardsInformationPinVerify');
    const header = {
        Authorization: 'Bearer ' + accessToken,
    };
    const query = {
        pin,
    };

    const payload = {
        header,
        query,
    };

    Api.post(url, payload).then(
        response => {
            if (response.body.status === 'OK') {
                callback(true);
            }
        },
        error => {
            callback(false, error.body.type);
        }
    );
};

export default {
    checkPinCard,
};
